// api/breakTimeLogApi.js
import apiClient from "./axios";

const breakTimeLogApi = {
  // getAll: async (page = 1, pageSize = 10, search = '', exclude_title = '', title, employee="", date_range='', filters = {}) => {
  //   const response = await apiClient.get('/break-time-logs/', {
  //     params: { page, page_size: pageSize, search, exclude_title, title, employee, date_range, ...filters },
  //   });
  //   return response.data;
  // },

  getAll: async ({
    page = 1,
    pageSize = 10,
    search = "",
    exclude_title = "",
    title = "",
    employee = "",
    date_range = "",
    filters = {},
  } = {}) => {
    const response = await apiClient.get("/break-time-logs/", {
      params: {
        page,
        page_size: pageSize,
        search,
        exclude_title,
        title,
        employee,
        date_range,
        ...filters,
      },
    });

    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post("/break-time-logs/", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/break-time-logs/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/break-time-logs/${id}/`);
    return id;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/break-time-logs/${id}/`);
    return response.data;
  },
  exportCsv: async (title = "", exclude_title = "", filters = {}) => {
    const response = await apiClient.get("/break-time-logs/export/", {
      params: { title, exclude_title, ...filters },
      responseType: "blob",
    });
    return response.data;
  },
};

export default breakTimeLogApi;
